export const SET_LOGIN_DATA = "set/login/data"
export const REMOVE_LOGIN_DATA = "remove/login/data"
export const GET_VERIFY_TOKEN = "get/verfiy/token"